'use client';

import type { PropsWithChildren } from 'react';
import type { InteractionType } from '~/model/InteractionType';
import { useLocale, useTranslations } from 'next-intl';
import { getLangAttributeValue } from '@/app/utils/entities/translation';
import { Link } from '@/i18n/routing';
import { AcceptLanguage } from '~/const/locale';
import { useProjectTabsContext } from '../provider/ProjectTabsProvider';

export const ProjectCard = ({
  interaction,
  children,
}: PropsWithChildren<{
  interaction: InteractionType;
}>) => {
  const t = useTranslations('INTERACTION');
  const locale = useLocale();
  const { activeTabFilter, setTab } = useProjectTabsContext();

  const originalLocale = interaction?.original_locale;
  const langValue = getLangAttributeValue(originalLocale, AcceptLanguage[locale]);

  return (
    <article className="project-card">
      {children}
      <Link
        className="project-card__opener"
        href={`/interactions/${interaction.id}`}
        onClick={(event) => {
          event.preventDefault();
          setTab(activeTabFilter, interaction.id);
        }}
        prefetch={false}
        scroll={false}
      >
        <span className="sr-only">
          {t('SEE_MORE')}
          {' '}
          <strong lang={langValue}>{interaction.title}</strong>
        </span>
      </Link>
    </article>
  );
};
